import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import lottie from 'lottie-web';
import PropTypes from 'prop-types';

import './styles.css';

const propTypes = {
  startAttack: PropTypes.bool.isRequired,
  handleStartAttack: PropTypes.func.isRequired,
  animationName: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
};

export default class AttackAnimation extends Component {
  componentDidMount() {
    const { animationName } = this.props;

    this.anim = lottie.loadAnimation({
      container: this.animationContainer,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: `/${animationName}.json`,
    });

    this.anim.addEventListener('DOMLoaded', this.playAnim);
    this.anim.addEventListener('complete', this.stopAttack);
  }

  playAnim = () => {
    this.anim.play();
  };

  stopAttack = () => {
    const { startAttack, handleStartAttack } = this.props;

    if (startAttack) {
      handleStartAttack();
      this.anim.destroy();
    }
  };

  render() {
    const { target, animationName } = this.props;

    return (
      <div className={`attack-animation-container ${target} ${animationName} ${isMobile ? 'mobile' : ''}`}>
        <div ref={ref => { this.animationContainer = ref; }} />
      </div>
    );
  }
}

AttackAnimation.propTypes = propTypes;
